import { render, staticRenderFns } from "./CreateJournal.vue?vue&type=template&id=2890b67a&scoped=true&"
import script from "./CreateJournal.vue?vue&type=script&lang=js&"
export * from "./CreateJournal.vue?vue&type=script&lang=js&"
import style0 from "./CreateJournal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CreateJournal.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./CreateJournal.vue?vue&type=style&index=2&id=2890b67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2890b67a",
  null
  
)

export default component.exports